const isHaskoningEmail = (email: string): string => {
	const emailRegexp =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!\.)(\w*\.)?haskoning\.com$/;
	if (emailRegexp.test(email)) {
		return '';
	}
	return 'Email should end in @haskoning.com or @subdomain.haskoning.com';
};

export default isHaskoningEmail;
